import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import InputCheckbox from '../../elements/InputCheckbox';

import ContactListModal from '../../modals/ContactListModal';
import OrderItemFinderModal from '../../modals/OrderItemFinderModal';
import OrderListModal from '../../modals/OrderListModal';
import CourierListModal from '../../modals/CourierListModal';
import CourierFormModal from '../../modals/CourierFormModal';
import initTreeView from '../../../services/initTreeView';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
 
export default function ShipmentForm (){
    const { shipment_id } = useParams();
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New Shipment');
    const [form_loaded, setRecordLoaded] = useState(0);
    const [form_data, setFormData] = useState(store.shipment_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]    );
    const [customer_data, setCustomer] = useState([]);
    const [customer_modal, setContactModal] = useState(0);
    const [so_list_modal, setSOModal] = useState(0);
    const [is_delivered, setIsDelivered] = useState(0);
    const dropdownRef = useRef(null);

    /** Modals */
    const [product_modal, setProductModal] = useState(0);
    const [enums, setEnums] = useState([]);
    const [couriers_list, setCouriersList] = useState([]);
    const [couriers_modal, setCouriersModal] = useState(0);

    const [customer_orders, setCustomerOrders] = useState([]);
   
    useEffect(() => {
        initTreeView()

        if(shipment_id){
            setPageTitle('Shipment Details')
            fetchData(shipment_id)
        }
        else{
            fetchEnums()
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    useEffect(() => {
        // if(customer_data?.id){
        //     console.log('customer_data', customer_data)
        //     fetchCustomerOrders(customer_data?.id)
        // }
    }, [customer_data]);

    

    useEffect(() => {

    }, [form_data.shipping_status_id]);

    function fetchData(shipment_id){
        if(!shipment_id){
            return
        }
        const url = helpers.createUrl('V1/manage/order/shipment/'+shipment_id+'?store_id='+helpers.getStoreID())

        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.shipment_date = new Date(res.shipment_date)
            if(res.delivered_date){
                items.delivered_date = new Date(res.delivered_date)
            }

            setLoading(0)
            setFormData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
            fetchEnums()

            if(res.delivered_date){
                setIsDelivered(1)
            }
        })
        .catch((err) => {
            setLoading(0)
            fetchEnums()

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    //return navigate("/item/list");
                    window.location.replace("/shipments/list");
                }
            })
        }); 
    }

    // function fetchEnums(){
    //     setLoading(1)
    //     const url = helpers.createUrl(`V1/manage/couriers/list?store_id=${helpers.getStoreID()}&pagination=0&with_default=1`)
    //     httpRequest(url, "GET", {}, true)
    //     .then((res) => {
    //         setLoading(0)
    //         setCouriersList(res)
    //     })
    //     .catch((err) => {
    //         setLoading(0)
    //     }); 
    // }

    function fetchEnums(){
        setLoading(1)

        const url = helpers.createUrl(`V1/enums/orders?store_id=${helpers.getStoreID()}`)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setEnums(res)
            setLoading(0)

            const default_warehouse = res?.warehouses?.[0]?.id
            setFormData(prev => ({ ...prev, warehouse_id: default_warehouse }));
        })
        .catch((err) => {
            setLoading(0)
        }); 
    }

    // function fetchCustomerOrders(customer_id){
    //     setLoading(1)

    //     const url = helpers.createUrl(`V1/manage/contact/${customer_id}/orders?store_id=${helpers.getStoreID()}`)
    //     httpRequest(url, "GET", {}, true)
    //     .then((res) => {
    //         console.log('customer order', res)
    //         //setEnums(res)
    //         setLoading(0)
    //         setCustomerOrders(res)

    //         //const default_warehouse = res?.warehouses?.[0]?.id
    //         //setFormData(prev => ({ ...prev, warehouse_id: default_warehouse }));
    //     })
    //     .catch((err) => {
    //         setLoading(0)
    //     }); 
    // }

    // function getCourierList(page = '', search = '', get_status = '',date_start='',date_end=''){
    //     let filter = `?store_id=${helpers.getStoreID()}&paginate=0&with_default=1&limit=0&`

    //     if(page){
    //         filter += 'page='+page+'&'
    //     }
    //     if(search){
    //         filter += 'search='+search+'&'
    //     }
    
    //     const queryString = window.location.search ?? '';
    //     const urlParams = new URLSearchParams(queryString);
    //     let param = urlParams.get('status') ?? '';

    //     if(param){
    //         filter += 'filter_by=status&filter='+param+'&'
    //     }

    //     if(get_status){
    //         filter += 'filter_by=status&filter='+get_status+'&'
    //     }

    //     if(date_start && date_end){
    //         filter += 'date_from='+date_start+'&'+'date_to='+date_end+'&'
    //     }

    //     filter = filter.slice(0, -1)

    //     setLoading(1)

    //     const url = helpers.createUrl('V1/manage/couriers/list'+filter)

    //     httpRequest(url, "GET", {}, true)
    //         .then((res) => {
    //             setCouriersList(res)
    //             setLoading(0)
    //         })
    //         .catch((err) => {
    //             //console.log(err)
    //             setLoading(0)
    //         }); 
    // }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>{data.product_name} ({data.product_variant_name})</td>
                    <td>{helpers.formatNumber(data.quantity)}</td>
                    {
                    form_loaded ?
                    <td>{helpers.formatNumber(data.fulfilled_quantity)}</td> : ''
                    }
                    <td>
                        <InputNumber
                            id="quantity_to_ship" 
                            name="quantity_to_ship" 
                            className="quantity-input"
                            inputStyle={{ minWidth: '100px' }}
                            value={data.quantity_to_ship}
                            // tagClass="form-control mb-0"
                            inputClassName="rounded-0"
                            // onChange={(e) => inputItemChange(e, key)}
                            min={0}
                            max={data.max_quantity}
                            onValueChange={(e) => inputItemChange(e, key)}
                            placeholder="Quanitity"
                            decrementButtonClassName="p-input-button-left" 
                            incrementButtonClassName="p-input-button-right" 
                            incrementButtonIcon="fas fa-plus" 
                            decrementButtonIcon="fas fa-minus"
                            buttonLayout="horizontal"
                            showButtons
                            disabled={parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5}
                        />
                    </td>
                    {
                        parseInt(form_data.shipping_status_id) === 1 && (
                        <td>
                            <button className='btn btn-danger btn-sm text-muteds' type="button" onClick={(e) => removeItem(key)}><i className="fas fa-trash text-dangers"></i></button>
                        </td>
                    )}
                </tr>)

            })
        }
        else{
            // items = <tr>
            //             <td colSpan={5} className='text-center'>&nbsp;</td>
            //         </tr>
        }


        setTableItems(items)
    }
    
    function inputItemChange(e, key) {
        let { value, name } = e.target;
        let items = [...record_items]
        let target = {...items[key]}

        target[name] = value
        items[key] = target

        setRecordItems(items)
    }

    function removeItem(key){
        let items = [...record_items]
        items.splice(key, 1); 

        setRecordItems(items)
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        if(name == 'is_delivered'){
            setIsDelivered(value)
            return;
        }

        if(name === 'courier_id'){
            
            let couriers = enums?.couriers.find((el) => {
                if(el.id === parseInt(value)){
                    return el
                }

            })
            new_state.courier = couriers.courier_name
        }

        setFormData({ ...form_data, ...new_state });
    }

    function handleProduct(e){
        let items = [...record_items]

        //console.log('product', e)
        const fulfilled_quantity = e.fulfilled_quantity;
        let remaining_quantity = e.quantity - fulfilled_quantity
        
        let available_stock = 9999999;
        if(e.track_inventory){
            available_stock = e.available_stock
        }

        // console.log({
        //     fulfilled_quantity: fulfilled_quantity,
        //     remaining_quantity: remaining_quantity,
        //     available_stock: available_stock
        // })

        let max_quantity = remaining_quantity;
        if(remaining_quantity > available_stock){
            max_quantity = e.available_stock
            remaining_quantity = e.available_stock
        }


        let new_item = {
            "product_id": e.product_id,
            "product_code": e.product_code,
            "product_name": e.product_name,
            "product_variant_id": e.product_variant_id,
            "product_variant_name": e.product_variant_name,
            "quantity": e.quantity,
            "quantity_to_ship": remaining_quantity,
            "fulfilled_quantity": remaining_quantity,
            "shipping_status_id": form_data.shipping_status_id,
            "sales_order_item_id": e.sales_order_item_id,
            "max_quantity": max_quantity
        }

        console.log('new_item', new_item)

        items.push(new_item)

        setRecordItems(items)
    }
    
    function handleOrder(e){
        let data = {...form_data}

        data.sales_order_id = e.id
        data.sales_order = e.order_no
        
        setRecordItems([])
        setFormData(data)
    }

    function handleSubmit(status){
        setLoading(1)

        let url = helpers.createUrl(`V1/manage/order/shipment/create`)
        if(shipment_id){
            url = helpers.createUrl(`V1/manage/order/shipment/${shipment_id}`)
        }

        let payloadData = {...form_data, 'shipping_status_id': status}
        payloadData['items'] = record_items;
        payloadData['sales_order'] = form_data.sales_order_id

        httpRequest(url, 'POST', {
            postdata: payloadData,
        }, true)
            .then((res) => {
                setLoading(0)

                let id = shipment_id;
                if(!id){
                    id = res.data.id
                }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace(`/shipments/${id}/form`);
                        return;
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                Swal.fire({
                    //title: err.message,
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    

    function handleCustomer(e){
        let data = {...form_data}
        let customer = {...customer_data}

        data.customer_id = e.id
        data.customer_name = e.contact_name
        data.customer_data = e

        data.sales_order_id = ''
        data.sales_order = ''

        customer.id = e.id
        customer.contact_name = e.contact_name

        setFormData(data)
        setCustomer(e)
    }

    function handleCourier(e){
        let data = {...form_data}

        data.courier_id = e.id
        data.courier = e.courier_name
        data.courier_name = e.courier_name

        setFormData(data)
        fetchEnums()
    }

    const handleAddModal = (type) => {
        dropdownRef.current?.hide();

        if(type === 'courier'){
            setCouriersModal(1)
        }
    };

    const dropdownFooterTemplate = (type) => {
        if(type === 'courier'){
            return (
                <div className='bg-light' style={{ padding: '10px', textAlign: 'center' }}>
                    <button className="btn btn-primary btn-sm" type="button" onClick={() => handleAddModal('courier')}>Add New <i className="fas fa-plus-circle" /></button>
                </div>
            );
        }
    };


    return (
        <>
                
        <CourierFormModal 
            show_modal={couriers_modal} 
            close_modal={setCouriersModal} 
            handleSave={handleCourier}
            //id={variant_type_id}
        />

        <ContactListModal is_show={customer_modal} setShow={setContactModal} handleSelect={handleCustomer} />

        <OrderListModal id={form_data.customer_id} is_show={so_list_modal} setShow={setSOModal} handleSelect={handleOrder} type="sales" />

        <OrderItemFinderModal 
            reference_id={form_data.customer_id} 
            is_show={product_modal} 
            setShow={setProductModal}  
            handleSelect={handleProduct} 
            exclude={record_items} 
            restrict_stock={false}
            show_price = {false}
            show_cost = {true}
            source='sales'
            order_id={form_data.sales_order_id}
            title="Ordered Items"
            warehouse_id = {form_data.warehouse_id}
        />

        <Layout page_title={page_title} menu="manage-shipments" breadcrumbs={true} parent_link='/shipments/list' parent_text="Manage Order Shipment">
                <div className="content-fluid">
                    <div className="container-fluid pb-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>

                        {form_data.shipment_no ?
                        <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                            <h5 className='mb-3 mb-md-0 d-flex'>{form_data.shipment_no}&nbsp;&nbsp;&nbsp;{helpers.displayShippingStatus(form_data.shipping_status_id, form_data.shipping_status)}</h5>
                            <div className='d-flex flex-column flex-sm-row'>
                            </div>

                            <div className='text-right'>  
                                {
                                parseInt(form_data.shipping_status_id) === 1 && (
                                <>
                                <button type='button' className='btn btn-outline-success mr-3' onClick={(e) => handleSubmit(1)} disabled={!form_data.sales_order || (is_delivered && !form_data.delivered_date)} style={{padding: '0.5rem 0.75rem'}}>Save as Draft</button>
                                <button type='button' className='btn btn-success mr-3' onClick={(e) => handleSubmit(3)} disabled={!form_data.sales_order || (is_delivered && !form_data.delivered_date)} style={{padding: '0.5rem 0.75rem'}}>Save</button>
                                </>)}              
                                <Link className='btn btn-secondary' to="/shipments/list" style={{padding: '0.5rem 0.75rem'}}>Close</Link>
                            </div>
                        </div> : ''}

                                            
                         {
                            parseInt(form_data.shipping_status_id) === 1 && !form_data?.shipment_no && (
                            <div className='text-right mb-4'>  
                                {
                                parseInt(form_data.shipping_status_id) === 1 && (
                                <>
                                <button type='button' className='btn btn-outline-success mr-3 ' onClick={(e) => handleSubmit(1)} disabled={!form_data.sales_order || (is_delivered && !form_data.delivered_date)} style={{padding: '0.5rem 0.75rem'}}>Save as Draft</button>
                                <button type='button' className='btn btn-success mr-3 ' onClick={(e) => handleSubmit(3)} disabled={!form_data.sales_order || (is_delivered && !form_data.delivered_date)} style={{padding: '0.5rem 0.75rem'}}>Save</button>
                                </>)}
                                <Link className='btn btn-secondary' to="/shipments/list" style={{padding: '0.5rem 0.75rem'}}>Close</Link>                  
                            </div>)}

                        <form id="pr-form">
                            <div className="row mb-2 d-flex align-items-stretch">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body pt-md-5">
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Customer<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                        {/* {
                                                            shipment_id ?
                                                            <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" placeholder="Select Customer" value={form_data.customer_name} disabled={true} />
                                                                <div className="input-group-append">
                                                                    <button className="btn btn-primary" type="button" onClick={(e) => setContactModal(1)} disabled={shipment_id}><i className="fas fa-search" /></button>
                                                                </div>
                                                            </div>
                                                            </> :
                                                            <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" placeholder="Select Customer" onClick={(e) => setContactModal(1)} value={form_data.customer_name} readOnly={true} />
                                                                <div className="input-group-append">
                                                                    <button className="btn btn-primary" type="button" onClick={(e) => setContactModal(1)} disabled={shipment_id}><i className="fas fa-search" /></button>
                                                                </div>
                                                            </div>
                                                            </>
                                                        } */}
                                                        <div className="p-inputgroup flex-1">
                                                            <InputText 
                                                                placeholder="Select Customer"
                                                                onClick={(e) => setContactModal(1)} 
                                                                value={form_data.customer_name} 
                                                                disabled={shipment_id ? true : false}
                                                            />
                                                            <Button 
                                                                icon="fas fa-search" 
                                                                className="p-button-primary" 
                                                                type="button"
                                                                onClick={(e) => setContactModal(1)}
                                                                disabled={shipment_id ? true : false}
                                                            />
                                                        </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Sales Order No<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3">
                                                        {/* {
                                                            shipment_id ?
                                                            <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" placeholder="Select SO" value={form_data.sales_order} disabled={true} /> 
                                                                <div className="input-group-append">
                                                                    <button className="btn btn-primary" type="button" disabled><i className="fas fa-search" /></button>
                                                                </div>
                                                            </div>
                                                            </>
                                                            :
                                                            <>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control" placeholder="Select SO" onClick={(e) => setSOModal(1)} onChange={(e) => setSOModal(1)} value={form_data.sales_order} disabled={!form_data.customer_id} />
                                                                <div className="input-group-append">
                                                                    <button className="btn btn-primary" type="button" onClick={(e) => setSOModal(1)} disabled={!form_data.customer_id}><i className="fas fa-search" /></button>
                                                                </div>
                                                            </div>
                                                            </>
                                                        } */}
                                                    <div className="p-inputgroup flex-1">
                                                        <InputText 
                                                            placeholder="Select Sales Order"
                                                            onClick={(e) => setSOModal(1)} 
                                                            value={form_data.sales_order}
                                                            disabled={
                                                                shipment_id ? true : 
                                                                    !form_data.customer_id ? true : false
                                                            }
                                                        />
                                                        <Button 
                                                            icon="fas fa-search" 
                                                            className="p-button-primary" 
                                                            type="button"
                                                            onClick={(e) => setSOModal(1)}
                                                            disabled={
                                                                shipment_id ? true : 
                                                                    !form_data.customer_id ? true : false
                                                            }
                                                        />
                                                    </div>
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="sales_order" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12"><hr/></div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Shipment Date<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <Calendar 
                                                        id="shipment_date" 
                                                        name="shipment_date"  
                                                        value={form_data.shipment_date} 
                                                        onChange={inputChange} 
                                                        className='w-100' 
                                                        dateFormat="yy-mm-dd"
                                                        maxDate={new Date()} 
                                                        icon={() => <i className="far fa-calendar"></i>} 
                                                        showIcon  
                                                        disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="shipment_date" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            {
                                            enums?.warehouses?.length && (
                                            <div className="row mb-2">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Warehouse<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <Dropdown  
                                                        name='warehouse_id'
                                                        value={form_data.warehouse_id} 
                                                        onChange={inputChange} 
                                                        options={enums.warehouses} 
                                                        optionLabel="warehouse_name" 
                                                        optionValue="id" 
                                                        placeholder="Select Warehouse" 
                                                        className="w-100" 
                                                        checkmark={true} 
                                                        highlightOnSelect={false} 
                                                        disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                    />

                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="sales_channel_id" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>)
                                            }
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Courier<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">

                                                    {/* <div className="input-group">
                                                        <input type="text" className="form-control" placeholder="Select Courier" value={form_data.courier} readOnly={1}  onClick={(e)=>setCouriersModal(1)} style={{backgroundColor: '#fff'}} disabled={!form_data.sales_order}/>
                                                        
                                                        <div className="input-group-append">
                                                            <button className="btn btn-primary" type="button" onClick={(e) => setCouriersModal(1)} title="Add Courier" disabled={!form_data.sales_order}>
                                                                <i className="fas fa-search" title="Add Courier" />
                                                            </button>
                                                        </div>
                                                    </div> */}
                                                        <Dropdown  
                                                            ref={dropdownRef}
                                                            name='courier_id'
                                                            value={form_data.courier_id}  
                                                            onChange={inputChange}
                                                            options={enums?.couriers} 
                                                            optionLabel="courier_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Courier" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                            className='w-100'
                                                            panelFooterTemplate={() => dropdownFooterTemplate('courier')}
                                                            disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                        />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="courier" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Tracking No</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputText
                                                        id="tracking_no" 
                                                        name="tracking_no" 
                                                        value={form_data.tracking_no}
                                                        className="mb-0 w-100"
                                                        placeholder="Tracking No"
                                                        onChange={inputChange}
                                                        disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="tracking_no" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className='mb-0'>Note</label><br/>
                                                    <small>(Internal only)</small>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputTextArea
                                                        id="notes" 
                                                        name="notes" 
                                                        value={form_data.notes}  
                                                        tagClass="form-control"
                                                        onChange={inputChange}
                                                        rows={2}
                                                        disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="notes" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-3 col-lg-2"></div>
                                                <div className="col-md-5 col-lg-4">
                                                        <InputCheckbox
                                                        id="is_delivered"
                                                        name="is_delivered"
                                                        value="1"
                                                        onChange={inputChange}
                                                        checked = {is_delivered}
                                                        tagClass='me-2'
                                                        label="Shipment Delivered"
                                                        labelClass="ms-2 font-weight-normal"
                                                        disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                        />
                                                </div>
                                            </div>
                                            {
                                                is_delivered ? 
                                            <>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                <label>Delivered Date<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <Calendar 
                                                        id="delivered_date" 
                                                        name="delivered_date"  
                                                        value={form_data.delivered_date} 
                                                        onChange={inputChange} 
                                                        className='w-100' 
                                                        dateFormat="yy-mm-dd" 
                                                        minDate={form_data.shipment_date}
                                                        icon={() => <i className="far fa-calendar"></i>} 
                                                        disabled={!form_data.sales_order}
                                                        showIcon  
                                                        disabled={!form_data.sales_order || (parseInt(form_data.shipping_status_id) === 3 || parseInt(form_data.shipping_status_id) === 4 || parseInt(form_data.shipping_status_id) === 5)}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="delivered_date" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            </> : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="so-item-container mt-5" className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body p-0 table-responsive">
                                            <table className='table mb-0'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th>Item</th>
                                                        <th width={150}>Ordered</th>
                                                        {
                                                        form_loaded ?
                                                        <th width={150}>Fulfilled</th> : ''
                                                        }
                                                        <th width={200}>Quantity&nbsp;to&nbsp;Ship</th>
                                                        {
                                                        parseInt(form_data.shipping_status_id) === 1 && (
                                                        <th width={20}></th>)}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {table_items}

                                                    {
                                                    parseInt(form_data.shipping_status_id) === 1 && (
                                                    <tr className='bg-light'>
                                                        <td colSpan={form_loaded ? 5 : 4} className='text-center'>
                                                            <center>
                                                            <RenderErrors 
                                                                errors={errors} 
                                                                name="items" 
                                                                className="text-danger mb-2"
                                                                style={{fontSize: '.9rem'}}
                                                            />
                                                            </center>
                                                            <button type="button" className="btn btn-outline-primary" onClick={(e) => setProductModal(1)} disabled={!form_data.sales_order_id}>Add Item</button>
                                                        </td>
                                                    </tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='text-right mt-3'>  
                                {
                                parseInt(form_data.shipping_status_id) === 1 && (
                                <>
                                <button type='button' className='btn btn-outline-success mr-3 ' onClick={(e) => handleSubmit(1)} disabled={!form_data.sales_order || (is_delivered && !form_data.delivered_date)} style={{padding: '0.5rem 0.75rem'}}>Save as Draft</button>
                                <button type='button' className='btn btn-success mr-3 ' onClick={(e) => handleSubmit(1)} disabled={!form_data.sales_order || (is_delivered && !form_data.delivered_date)} style={{padding: '0.5rem 0.75rem'}}>Save</button>
                                </>)}

                                <Link className='btn btn-secondary' to="/shipments/list" style={{padding: '0.5rem 0.75rem'}}>Close</Link>                  
                            </div>
                        </form>
                    </div>
                </div>
        </Layout>
        </>
    )
}